


import { getKeyMetadata } from '../helpers/getKeyMetadata';
import { EncryptedKey, KeyMetadata, KeyStore } from "../types";
import { CapacitorStorageFacade, SecureStorageConfigParams } from './CapacitorStorage.Facade';

 export class CapacitorKeyStore implements KeyStore {
    public name: string;
    private keyStore: CapacitorStorageFacade;
  
    constructor() {
      this.name = "CapacitorStorage";
      this.keyStore = new CapacitorStorageFacade();
    }
  
    /**
     * @param {LocalStorageConfigParams} params A configuration object.
     * @param {Storage} params.storage The Storage instance. Required.
     * @param {string} [params.prefix] The prefix for the names in the storage.
     * @return {Promise}
     */
    public configure(params: SecureStorageConfigParams): Promise<any> {
      try {
        this.keyStore.configure(params);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    }
  
    public storeKeys(keys: EncryptedKey[]) {
      // We can't store keys if they're already there
      
      // const invalidKeys: EncryptedKey[] = keys.filter(
      //   (encryptedKey: EncryptedKey) => this.keyStore.hasKey(encryptedKey.id),
      // );

      // if (invalidKeys.length) {
      //   return Promise.reject(
      //     `Some keys were already stored in the keystore: ${invalidKeys
      //       .map((k) => k.id)
      //       .join(", ")}`,
      //   );
      // }
  
      const keysMetadata = keys.map((encryptedKey: EncryptedKey) => {
        this.keyStore.setKey(encryptedKey.id, encryptedKey);
        return getKeyMetadata(encryptedKey);
      });
  
      return Promise.resolve(keysMetadata);
    }
  
    public updateKeys(keys: EncryptedKey[]) {
      // we can't update keys if they're already stored
      const invalidKeys: EncryptedKey[] = keys.filter(
        (encryptedKey: EncryptedKey) => !this.keyStore.hasKey(encryptedKey.id),
      );
  
      if (invalidKeys.length) {
        return Promise.reject(
          `Some keys couldn't be found in the keystore: ${invalidKeys
            .map((k) => k.id)
            .join(", ")}`,
        );
      }
  
      const keysMetadata = keys.map((encryptedKey: EncryptedKey) => {
        this.keyStore.setKey(encryptedKey.id, encryptedKey);
        return getKeyMetadata(encryptedKey);
      });
  
      return Promise.resolve(keysMetadata);
    }
  
    public loadKey(id: string) {
      const key = this.keyStore.getKey(id);
      if (!key) {
        return Promise.reject(id);
      }
      return Promise.resolve(key);
    }
  
    public async removeKey(id: string) {
     
        if (!this.keyStore.hasKey(id)) {
        return Promise.reject(id);
      }
  
      const keyStoreKeyId = await this.keyStore.getKey(id)
      const metadata: KeyMetadata = getKeyMetadata(keyStoreKeyId);
      this.keyStore.removeKey(id);
  
      return Promise.resolve(metadata);
    }
  
    public loadAllKeys() {
      return Promise.resolve(this.keyStore.getAllKeys());
    }

  }